<div class="summary">
  <div class="modal-header-summary">
    <div class="cross-wrapper">
      <nb-icon icon="check" pack="icomoon" class="icon"></nb-icon>
    </div>
    <h2 class="fontsize30">{{ 'view_translations.traffic_source_adding_confirmation' | translate }}</h2>
  </div>
  <div class="info-section">
    <div>
      <h3 class="font500">{{ 'view_translations.traffic_source_verifying_info' | translate }}</h3>
      <h4 class="font500 fontsize16 info-text-secondary">{{ 'view_translations.support_information' | translate }}</h4>
    </div>
  </div>
  <hr class="separator" *ngIf="verificationInformation" />
  <div class="content-summary" *ngIf="verificationInformation">
    <h3 class="fontsize16 font700">1. {{ 'view_translations.put_metatag_in_source_of_homepage' | translate }}</h3>
    <div class="copy-container d-flex justify-content-start">
      <textarea readonly rows="2" type="text" [(ngModel)]="textareaValues.metatag" #metatagInput></textarea>
      <div class="copy-button" (click)="copyToken(metatagInput)">
        <nb-icon icon="copy" pack="icomoon"></nb-icon>
      </div>
    </div>
    <h3 class="fontsize16 font700">2. {{ 'view_translations.put_html_comment_in_source_of_homepage' | translate }}</h3>
    <div class="copy-container d-flex justify-content-start">
      <textarea readonly rows="1" [(ngModel)]="textareaValues.comment" type="text" #commentInput></textarea>
      <div class="copy-button" (click)="copyToken(commentInput)">
        <nb-icon icon="copy" pack="icomoon"></nb-icon>
      </div>
    </div>
    <h3 class="fontsize16 font700">3. {{ 'view_translations.publish_token_on_website' | translate }}</h3>
    <div class="copy-container d-flex justify-content-start">
      <textarea readonly rows="1" [(ngModel)]="textareaValues.token" type="text" #tokenInput></textarea>
      <div class="copy-button" (click)="copyToken(tokenInput)">
        <nb-icon icon="copy" pack="icomoon"></nb-icon>
      </div>
    </div>
    <div class="token-info d-flex justify-content-start align-items-start">
      <nb-icon icon="info" pack="icomoon"></nb-icon>
      <p class="token-info-text fontsize13 font500">{{ 'view_translations.token_removing _information' | translate }}</p>
    </div>
    <div class="url-container">
      <h3 class="fontsize16 font700">* {{ 'custom_url_description' | t }}</h3>
      <app-text-input
        (emitValue)="setCustomUrl($event)"
        [fieldInfo]="{system_name: 'custom_url'}"
        [configurationData]="[{system_name: 'custom_url'}]"
        [submitted]="false"
        [inputName]="'custom_url'"
        [type]="'text'"
        [prefixText]=" url + '/'">
      </app-text-input>
    </div>
  </div>
  <hr class="separator" />
  <div class="modal-footer d-flex justify-content-start align-items-center">
    <app-primary-button
      *ngIf="verificationInformation"
      [buttonText]="'payouts_verify_modal_btn'"
      [icon]="''"
      [iconSize]="12"
      [background]="'orange'"
      (click)="checkVerification()">
    </app-primary-button>
    <!-- <app-secondary-button
      class="secondary-button font500"
      [iconSize]="12"
      [text]="'contact_support'"
      [icon]=""
      [largeButton]="false"
      [backgroundColor]="'grey'"
      [font500]="true"
      (click)="contactSupport()">
    </app-secondary-button> -->
  </div>
</div>
